<template>
  <div class="widget-list-item" @click="onClick">
    <div class="image-content-widget">
      <div class="image-widget">
        <slot></slot>
      </div>
      <div class="content-widget">
        <h2>{{ title }}</h2>
        <h4>{{ content }}</h4>
      </div>
    </div>
    <div class="option">
      <button class="btn-go">
        <img src="@/assets/images/icons/curret_right_black.svg" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget-list-item",
  props: {
    title: {
      type: String,
      default: "Title",
    },
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>
<style lang="scss" scoped>
.widget-list-item {
  width: 100%;
  background: #feffff;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #f6f7f7;
  }
  .image-content-widget {
    display: flex;
    align-items: center;
    .image-widget {
      object-fit: cover;
      border-radius: 50%;
      margin-right: 20px;
      img {
        width: 50px;
        height: 50px;
      }
    }
    .content-widget {
      h2 {
        font-weight: 600;
        font-size: 15px;
        color: #11142d;
        margin-bottom: 6px;
      }
      h4 {
        font-weight: 600;
        font-size: 14px;
        color: #808191;
      }
    }
  }
  .option {
    .btn-go {
      background: transparent;
      border: none;
      width: 6px;
    }
  }
}
</style>
